module.exports = __webpack_public_path__ + "static/chocolate_shell-9f9a7ea8534e6be44eb712fb470da97e.jpg";